import { render, staticRenderFns } from "./CuadroDeDialogo.vue?vue&type=template&id=568710e6&"
import script from "./CuadroDeDialogo.vue?vue&type=script&lang=js&"
export * from "./CuadroDeDialogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports